<template>
  <d2-container>

    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
                  v-model="searchForm.content"
                  placeholder="反馈意见"
                  style="width: 200px;"
          />
        </el-form-item>

        <el-form-item
        >
          <el-input
                  v-model="searchForm.moblie"
                  placeholder="反馈人手机号码"
                  style="width: 200px;"
          />
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.is_reply"
                  placeholder="平台是否回复"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.velue"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>

    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="微信呢称"
      >
        <template slot-scope="scope">
          {{scope.row.username}}
        </template>
      </el-table-column>



      <el-table-column
        label="微信图像"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.avatarUrl !== ''" > <img :src= "getImgUrl2(scope.row.avatarUrl)" 　style="width: 200px;height: 100px; " /></div>
        </template>
      </el-table-column>
      <el-table-column
              label="反馈意见"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.content}}
        </template>
      </el-table-column>
      <el-table-column
              label="图片"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.url !== ''" > <img :src= "getImgUrl(scope.row.url)"   @click="previewPic(scope.row.url)" style="width: 200px;height: 100px; " /></div>
        </template>
      </el-table-column>
      <el-table-column
              label="QQ/邮箱"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.email}}
        </template>
      </el-table-column>
      <el-table-column
              label="手机号码"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.moblie}}
        </template>
      </el-table-column>
      <el-table-column
              label="提交时间"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.insert_times}}
        </template>
      </el-table-column>

      <el-table-column
              label="平台是否回复"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.is_reply=='0'">
            未回复
          </div>
          <div v-else-if="scope.row.is_reply=='1'">
           已回复
          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="回复内容"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.reply_content}}
        </template>
      </el-table-column>

      <el-table-column
              label="回复图片"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.reply_url !== ''" > <img :src= "getImgUrl(scope.row.reply_url)"   @click="previewPic(scope.row.reply_url)" 　style="width: 200px;height: 100px; " /></div>
        </template>
      </el-table-column>

      <el-table-column
              label="回复时间"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.reply_times}}
        </template>
      </el-table-column>


      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="200"
      >
          <template slot-scope="scope">
            <el-button type="primary" plain  size="mini"        v-if="scope.row.is_reply=='0'"  @click="openViewForm(scope.row)">平台回复</el-button>



          </template>
      </el-table-column>

    </el-table>
     <!-- 图片预览 -->

          <el-dialog :visible.sync="dialogVisible" :modal="false" title="图片预览" width="50%">

            <img :src="previewpic" alt=""  width="100%" />

            <span slot="footer" class="dialog-footer">

              <el-button type="primary" @click="dialogVisible = false">确 定</el-button>

            </span>

          </el-dialog>

      <!-- 图片预览 -->
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>

    <view-form
            :agent="agent"
            v-model="viewFormVisible"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import util from '@/libs/util.js'
import viewForm from "./viewForm"
import * as agentService from "@/api/sys/agent";
export default {
  name: "EquipmentPage",
  components: { viewForm },
  data() {
    return {
      searchForm: {
        content: "",
        moblie: "",
      },
        dateRange: [],
        is_dl_type:'',
        pickerOptions:{},
      loading: false,
      dialogVisible: false,

      previewpic: "",
      tableData: [],
      multipleSelection: [],
        typeOptions: [
            {
                value: "0",
                label: "未回复"
            },
            {
                value: "1",
                label: "已回复"
            }
        ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        agent: {},
        viewFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getAgentReplyPagedList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getImgUrl(val){
      var good_url=val;
      if(good_url.match(",")){
        var str = good_url.split(',');
        good_url=str[1];
      }
      return "https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/"+good_url;
    },
    previewPic(good_url) {

      this.previewpic ="https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/"+good_url;

      this.dialogVisible = true;

    },
    getImgUrl2(val){
      return val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },

      openViewForm(agent) {
          this.agent = agent;
          this.viewFormVisible = true;
      },
    del(noticeId) {
        let msg = "删除";
      this.$confirm("确认"+msg+"操作？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: "取消"
      }).then(() => {
          noticeService.delNotice({noticeId:noticeId}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
